/* eslint-disable prettier/prettier */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { AxiosResponse } from 'axios';
import {
  AccessData,
  DirectionData,
  FamiliarData,
  PersonalData,
  PrefijoPais,
  TiposDocumento,
  TiposVia,
} from '../../types/PersonalData';
import useAPIError from '../../hooks/useAPIError';
import DataService from '../../services/MisDatosService';
import { useAuthStore } from '../../store/AuthContext';
import useSessionChecking from '../../hooks/useSessionChecking';
import { StorageHelper } from '../../utils/StorageHelper';
import { BackMappings } from '../../utils/BackMappings';
import { GtmConstants } from '../../utils/GtmConstants';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import MisDatosCaprabo from './indexCaprabo';
import MisDatosEroski from './indexEroski';
import NotFound from '../NotFound';
import NoData from '../../components/NoData';
import { HostProvider } from '../../utils/HostProvider';
import { CryptoUtil } from '../../utils/CryptoUtil';
import { MisDatosConstants } from '../../utils/MisDatosConstants';
import { useAppStore } from '../../store/AppContext';
import { useMisDatosStore } from './context/MisDatos.context';

interface Props {
  showChangePass?: boolean;
  showChangeMail?: boolean;
  showBaja?: boolean;
}

const MisDatos: FC<Props> = (props) => {
  const { changeUserName, handleModalDatosPersonales } = useAppStore();
  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.MISDATOS);
  useSessionChecking(BackMappings.MISDATOS, setGoOn, goOn);

  const dataUser = useAuthStore();
  const [load, setLoad] = useState<boolean>(false);
  const [visiblePersonalData, setVisiblePersonalData] = useState(false);
  const { promiseInProgress } = usePromiseTracker();
  const [personalData, setPersonalData] = useState<PersonalData>({
    nombreCompleto: '',
    fechaNacimiento: '',
    idDocumento: '',
    tipoDocumento: -1,
    genero: '',
    prefijoTelefono: '-1',
    telefono: '',
    prefijoTelefonoSecundario: '-1',
    telefonoSecundario: '',
    emailContacto: '',
    idiomaComunicacion: '',
    nombre: '',
    apellido1: '',
    apellido2: '',
    tipoUsuario: -1,
    tipoSocioConsumidor: -1,
    tipoCambioMail: '',
    razonSocial: '',
    dniEditable: false,
    fromApp: '',
  });
  const [familiarData, setFamiliarData] = useState<FamiliarData>({
    esFamiliaNumerosa: false,
    numeroCarnet: '',
    fechaCaducidad: '',
  });
  const [directionData, setDirectionData] = useState<DirectionData[]>([]);
  const [directionDataNew] = useState<DirectionData>({
    tipoDireccion: -1,
    idDireccion: '',
    roadType: '',
    roadTypeDesc: '',
    roadName: '',
    idCalle: -1,
    number: '',
    portal: '',
    stairs: '',
    floor: '',
    door: '',
    postalCode: '',
    locality: '',
    province: '',
    country: '',
    directionName: '',
    reception: '',
    flgZonaCoop: false,
    flgDireccionHabitual: -1,
    onlyPostalCode: false,
    idFacturacion: -1,
    telefono: '',
    telefono1: '',
    telefono2: '',
    cif: '',
    cifFacturacion: '',
    razonSocial: '',
    idPrefTelefono1: '1',
    idPrefTelefono2: '1',
    glPlaceId: '',
    glPlaceLongitud: '',
    glPlaceLatitud: '',
    glPlaceType: '',
    nombre: '',
    apellido1: '',
    apellido2: '',
    numDoc: '',
    tipoDoc: 1,
    tipoDocKosmos: '',
    localityType: '',
  });
  const [onLoadDirectionModal, setOnLoadDirectionModal] = useState<boolean>(
    false,
  );
  const dataApp = useAppStore();
  const handlerModal = (data: PersonalData) => {
    setPersonalData(data);
    setVisiblePersonalData(true);
  };
  const { showBaja, showChangeMail, showChangePass } = props;
  const [tipo, setTipo] = useState('' as string);
  const { t } = useTranslation();
  const [userForm, setUserForm] = useState<boolean>(showChangeMail as boolean);
  const [passForm, setPassForm] = useState<boolean>(showChangePass as boolean);
  const [showBajaForm, setShowBajaForm] = useState<boolean>(
    showBaja as boolean,
  );
  const [showOpinionForm, setShowOpinionForm] = useState<boolean>(false);
  const [showGraciasForm, setShowGraciasForm] = useState<boolean>(false);
  const [showAccessData, setShowAccessData] = useState<boolean>(false);
  const [prefijosPaises, setPrefijosPaises] = useState<PrefijoPais[]>([]);
  const [prefijosPaisesMixtos, setPrefijosPaisesMixtos] = useState<
    PrefijoPais[]
  >([]);
  const [tiposDocumento, setTiposDocumento] = useState<TiposDocumento[]>([]);
  const [tiposVia, setTiposVia] = useState<TiposVia[]>([]);
  const [isDigital, setIsDigital] = useState<boolean>(false);
  const [isSocioEroski, setIsSocioEroski] = useState<boolean>(false);
  const { addError, addErrorBack } = useAPIError();
  const [accessData, setAccessData] = useState<AccessData>({
    dobleVerificacion: false,
    emailAcceso: '',
  });
  const [showBajaProcessModal, setShowBajaProcessModal] = useState<boolean>(
    false,
  );
  const [firstCharge1, setFirstCharge1] = useState(true);
  const [firstCharge2, setFirstCharge2] = useState(true);
  const [firstCharge3, setFirstCharge3] = useState(true);
  const [firstCharge4, setFirstCharge4] = useState(true);
  const [firstCharge5, setFirstCharge5] = useState(true);
  const [firstCharge6, setFirstCharge6] = useState(true);
  const [firstCharge7, setFirstCharge7] = useState(true);

  const [cuentaBloqueada, setCuentaBloqueada] = useState<boolean>(false);
  const {
    setPrefijosPaisesHabilitados,
    showModalTelefono1,
  } = useMisDatosStore();

  /**
   * Recupera los prefijos de los paises.
   *
   * @returns void.
   */
  const retrievePrefijosPais = () => {
    DataService.prefijoPais()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge4 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else if (typeof response.data.pojos !== 'undefined') {
          setPrefijosPaises(response.data.pojos);
          setPrefijosPaisesHabilitados(response.data.pojos);
        }
        setFirstCharge4(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const validarPrefijoPais = async () => {
    try {
      const response = await DataService.prefijoPais();
      return response;
    } catch (error) {
      console.error(error);
      return [];
    }
  };
  const isAxiosResponse = (response: any): response is AxiosResponse<any> => {
    return 'data' in response;
  };

  useEffect(() => {
    validarPrefijoPais().then((response) => {
      if (isAxiosResponse(response)) {
        console.log('response de prefijo: ', response?.data?.pojos);
        dataApp.hadlePrefijoHabilitado(response?.data?.pojos);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const retrievePrefijosPaisMixto = () => {
    DataService.prefijoPaisMixtos()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge5 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else if (typeof response.data.pojos !== 'undefined') {
          setPrefijosPaisesMixtos(response.data.pojos);
        }
        setFirstCharge5(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const retrieveTiposDocumento = () => {
    DataService.getTiposDocumento()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge6 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else if (typeof response.data.pojos !== 'undefined') {
          setTiposDocumento(response.data.pojos);
        }
        setFirstCharge6(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const retrieveTiposVia = () => {
    DataService.getTiposViaParaDirecciones()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge7 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else if (typeof response.data.pojos !== 'undefined') {
          setTiposVia(response.data.pojos);
        }
        setFirstCharge7(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const retrieveDirections = () => {
    DataService.direcciones()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge3 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else if (typeof response.data.pojos !== 'undefined') {
          for (let i = 0; i < response.data.pojos.length; i += 1) {
            response.data.pojos[i].postalCode = CryptoUtil.decryptAes(
              response.data.pojos[i].postalCode,
            );
            response.data.pojos[i].roadType = CryptoUtil.decryptAes(
              response.data.pojos[i].roadType,
            );
            response.data.pojos[i].roadName = CryptoUtil.decryptAes(
              response.data.pojos[i].roadName,
            );
            response.data.pojos[i].number = CryptoUtil.decryptAes(
              response.data.pojos[i].number,
            );
            response.data.pojos[i].portal = CryptoUtil.decryptAes(
              response.data.pojos[i].portal,
            );
            response.data.pojos[i].stairs = CryptoUtil.decryptAes(
              response.data.pojos[i].stairs,
            );
            response.data.pojos[i].floor = CryptoUtil.decryptAes(
              response.data.pojos[i].floor,
            );
            response.data.pojos[i].door = CryptoUtil.decryptAes(
              response.data.pojos[i].door,
            );
            response.data.pojos[i].locality = CryptoUtil.decryptAes(
              response.data.pojos[i].locality,
            );
            response.data.pojos[i].directionName = CryptoUtil.decryptAes(
              response.data.pojos[i].directionName,
            );
            response.data.pojos[i].reception = CryptoUtil.decryptAes(
              response.data.pojos[i].reception,
            );
            response.data.pojos[i].email = CryptoUtil.decryptAes(
              response.data.pojos[i].email,
            );
            response.data.pojos[i].idPrefTelefono1 = CryptoUtil.decryptAes(
              response.data.pojos[i].idPrefTelefono1,
            );
            response.data.pojos[i].telefono1 = CryptoUtil.decryptAes(
              response.data.pojos[i].telefono1,
            );
            response.data.pojos[i].glPlaceId = CryptoUtil.decryptAes(
              response.data.pojos[i].glPlaceId,
            );
            response.data.pojos[i].glPlaceLongitud = CryptoUtil.decryptAes(
              response.data.pojos[i].glPlaceLongitud,
            );
            response.data.pojos[i].glPlaceLatitud = CryptoUtil.decryptAes(
              response.data.pojos[i].glPlaceLatitud,
            );
            response.data.pojos[i].glPlaceType = CryptoUtil.decryptAes(
              response.data.pojos[i].glPlaceType,
            );
          }
          setDirectionData(response.data.pojos);
          if (StorageHelper.isOpenDireccionHabitual()) {
            document.body.classList.add('fix');
          }
        }
        setFirstCharge3(false);
      })
      .catch(() => {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  const { showModalV2P } = useMisDatosStore();
  const getData = async () => {
    const accesdataResponse = await DataService.accessData({});
    console.log('accesdataResponse: ', accesdataResponse);
    const { dobleVerificacion } = accesdataResponse.data.pojo;
    setAccessData({
      emailAcceso: CryptoUtil.decryptAes(
        accesdataResponse.data.pojo.emailAcceso,
      ),
      dobleVerificacion: dobleVerificacion,
    });
    if (!dobleVerificacion) {
      showModalV2P();
    }
  };

  const fetchCuentaBloqueada = async () => {
    try {
      const response = await DataService.getCuentaBloqueada();
      setCuentaBloqueada(response.data);
    } catch (error) {
      console.error('Error al obtener el estado de la cuenta:', error);
    }
  };

  const getPersonalData = () => {
    DataService.personalData(false)
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge1 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else if (response.data && response.data.pojo) {
          response.data.pojo.idDocumento = CryptoUtil.decryptAes(
            response.data.pojo.idDocumento,
          );
          response.data.pojo.tipoDocumento = CryptoUtil.decryptAes(
            response.data.pojo.tipoDocumento,
          );
          response.data.pojo.nombre = CryptoUtil.decryptAes(
            response.data.pojo.nombre,
          );
          response.data.pojo.apellido1 = CryptoUtil.decryptAes(
            response.data.pojo.apellido1,
          );
          response.data.pojo.apellido2 = CryptoUtil.decryptAes(
            response.data.pojo.apellido2,
          );
          response.data.pojo.prefijoTelefono = CryptoUtil.decryptAes(
            response.data.pojo.prefijoTelefono,
          );
          response.data.pojo.telefono = CryptoUtil.decryptAes(
            response.data.pojo.telefono,
          );
          const prefijoSecundarioDesencriptado = CryptoUtil.decryptAes(
            response.data.pojo.prefijoTelefonoSecundario,
          );

          response.data.pojo.prefijoTelefonoSecundario =
            prefijoSecundarioDesencriptado === '20'
              ? ''
              : prefijoSecundarioDesencriptado;

          response.data.pojo.telefonoSecundario = CryptoUtil.decryptAes(
            response.data.pojo.telefonoSecundario,
          );
          response.data.pojo.emailContacto = CryptoUtil.decryptAes(
            response.data.pojo.emailContacto,
          );
          if (
            response.data.pojo.tipoUsuario ===
            MisDatosConstants.ID_TIPO_USUARIO_EMPRESA
          ) {
            response.data.pojo.razonSocial = CryptoUtil.decryptAes(
              response.data.pojo.razonSocial,
            );
            response.data.pojo.cif = CryptoUtil.decryptAes(
              response.data.pojo.cif,
            );
          } else {
            response.data.pojo.fechaNacimiento = CryptoUtil.decryptAes(
              response.data.pojo.fechaNacimiento,
            );
            response.data.pojo.genero = CryptoUtil.decryptAes(
              response.data.pojo.genero,
            );
          }
          changeUserName(response.data.pojo.nombre);
          setPersonalData(response.data.pojo);

          // Extraer y asignar datos de familia numerosa
          if (response.data.pojo.esFamiliaNumerosa !== undefined) {
            setFamiliarData({
              esFamiliaNumerosa: response.data.pojo.esFamiliaNumerosa,
              numeroCarnet: response.data.pojo.numeroCarnet,
              fechaCaducidad: response.data.pojo.fechaCaducidad,
            });
          }

          if (StorageHelper.isOpenPersonalData()) {
            handlerModal(response.data.pojo);
            document.body.classList.add('fix');
          }
          if (StorageHelper.getOpenTelefonoError()) {
            showModalTelefono1();
          }
        }
        setFirstCharge1(false);
      })
      .catch(() => {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const getFamiliarData = () => {
    DataService.familiarData()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge2 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else if (response.data && response.data.pojo) {
          setFamiliarData(response.data.pojo);
          if (StorageHelper.isOpenPersonalData()) {
            handlerModal(response.data.pojo);
            document.body.classList.add('fix');
          }
        }
        setFirstCharge2(false);
      })
      .catch(() => {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  function callServices() {
    getData()
      .then(() => {
        getPersonalData();
      })
      .then(() => {
        retrieveDirections();
      })
      .then(() => {
        retrievePrefijosPais();
      })
      .then(() => {
        retrievePrefijosPaisMixto();
      })
      .then(() => {
        retrieveTiposDocumento();
      })
      .then(() => {
        retrieveTiposVia();
      })
      .then(() => {
        fetchCuentaBloqueada();
      })
      .then(() => {
        setLoad(true);
      });
  }

  useEffect(() => {
    if (
      dataUser.user.token !== '' &&
      dataUser.user.isRecuerdame !== undefined &&
      !StorageHelper.getLogout()
    ) {
      setShowAccessData(true);
      callServices();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token]);

  useEffect(() => {
    if (
      !StorageHelper.getLogout() &&
      dataUser.user.isRecuerdame !== undefined
    ) {
      if (dataUser.user.token !== '') {
        callServices();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token, i18n.language]);

  useEffect(() => {
    if (dataApp.mostrarModalDatosPersonales) {
      setVisiblePersonalData(true);
      handleModalDatosPersonales(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataApp.mostrarModalDatosPersonales]);

  const fullPath = window.location.href;
  if (fullPath.includes('#')) {
    const index = fullPath.indexOf('#');
    const htmlAnchor = fullPath.slice(index, fullPath.length);
    if (htmlAnchor.includes('datos__bloque-suscripciones'))
      StorageHelper.setScrollSuscripciones(htmlAnchor);
    if (htmlAnchor.includes('datos__bloque-preferencia'))
      StorageHelper.setScrollPreferencia(htmlAnchor);
  }
  useDatalayerEvents(GtmConstants.MI_CUENTA);

  if (goOn && !StorageHelper.getLogout()) {
    if (load) {
      if (isEroski) {
        return (
          <MisDatosEroski
            showBaja={props.showBaja}
            showFamily={isCaprabo}
            showChangeMail={props.showChangeMail}
            showChangePass={props.showChangePass}
            dataUser={dataUser}
            handlerModal={handlerModal}
            personalData={personalData}
            getPersonalData={getPersonalData}
            getFamiliarData={getFamiliarData}
            familiarData={familiarData}
            setUserForm={setUserForm}
            setPassForm={setPassForm}
            accessData={accessData}
            load={load}
            promiseApi={promiseInProgress}
            getData={getData}
            prefijosPaises={prefijosPaises}
            setVisiblePersonalData={setVisiblePersonalData}
            directionData={directionData}
            setDirectionData={setDirectionData}
            tipo={tipo}
            setTipo={setTipo}
            retrieveDirections={retrieveDirections}
            setOnLoadDirectionModal={setOnLoadDirectionModal}
            isDigital={isDigital}
            setIsDigital={setIsDigital}
            isSocioEroski={isSocioEroski}
            setIsSocioEroski={setIsSocioEroski}
            setShowBajaForm={setShowBajaForm}
            showBajaProcessModal={showBajaProcessModal}
            setShowBajaProcessModal={setShowBajaProcessModal}
            visiblePersonalData={visiblePersonalData}
            setPersonalData={setPersonalData}
            setFamiliarData={setFamiliarData}
            tiposDocumento={tiposDocumento}
            tiposVia={tiposVia}
            prefijosPaisesMixtos={prefijosPaisesMixtos}
            onLoadDirectionModal={onLoadDirectionModal}
            directionDataNew={directionDataNew}
            userForm={userForm}
            passForm={passForm}
            showBajaForm={showBajaForm}
            setShowOpinionForm={setShowOpinionForm}
            showOpinionForm={showOpinionForm}
            setShowGraciasForm={setShowGraciasForm}
            showGraciasForm={showGraciasForm}
            showAccessData={showAccessData}
            cuentaBloqueada={cuentaBloqueada}
          />
        );
      }
      if (isCaprabo) {
        return (
          <MisDatosCaprabo
            showBaja={props.showBaja}
            showFamily={isCaprabo}
            showChangeMail={props.showChangeMail}
            showChangePass={props.showChangePass}
            dataUser={dataUser}
            handlerModal={handlerModal}
            personalData={personalData}
            getPersonalData={getPersonalData}
            getFamiliarData={getFamiliarData}
            familiarData={familiarData}
            setUserForm={setUserForm}
            setPassForm={setPassForm}
            accessData={accessData}
            load={load}
            promiseApi={promiseInProgress}
            getData={getData}
            prefijosPaises={prefijosPaises}
            setVisiblePersonalData={setVisiblePersonalData}
            directionData={directionData}
            setDirectionData={setDirectionData}
            tipo={tipo}
            setTipo={setTipo}
            retrieveDirections={retrieveDirections}
            setOnLoadDirectionModal={setOnLoadDirectionModal}
            isDigital={isDigital}
            setIsDigital={setIsDigital}
            isSocioEroski={isSocioEroski}
            setIsSocioEroski={setIsSocioEroski}
            setShowBajaForm={setShowBajaForm}
            showBajaProcessModal={showBajaProcessModal}
            setShowBajaProcessModal={setShowBajaProcessModal}
            visiblePersonalData={visiblePersonalData}
            setPersonalData={setPersonalData}
            setFamiliarData={setFamiliarData}
            tiposDocumento={tiposDocumento}
            tiposVia={tiposVia}
            prefijosPaisesMixtos={prefijosPaisesMixtos}
            onLoadDirectionModal={onLoadDirectionModal}
            directionDataNew={directionDataNew}
            userForm={userForm}
            passForm={passForm}
            showBajaForm={showBajaForm}
            setShowOpinionForm={setShowOpinionForm}
            showOpinionForm={showOpinionForm}
            setShowGraciasForm={setShowGraciasForm}
            showGraciasForm={showGraciasForm}
            showAccessData={showAccessData}
            cuentaBloqueada={cuentaBloqueada}
          />
        );
      }
      return <NotFound />;
    }
    return <NoData />;
  }
  return <></>;
};

export default MisDatos;
